import type { KeyboardEvent, ReactElement } from 'react';
import type { SelectableCardProps } from './SelectableCard.types';

export const SelectableCard = ({ selectionMode, selected, onSelect, children }: SelectableCardProps): ReactElement => {
  if (!onSelect) return children({});

  const role = selectionMode === 'single' ? 'radio' : 'checkbox';

  const handleKeyDown = (event: KeyboardEvent<HTMLElement>) => {
    if (event.target !== event.currentTarget) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    onSelect?.();
  };

  return children({ role, 'aria-checked': selected, tabIndex: 0, onClick: onSelect, onKeyDown: handleKeyDown });
};
